import React from 'react';
import CommunicationEventGrid from './CommunicationEventGrid';

export default function CommunicationEvent() {
  return <CommunicationEventGrid />;
}
